var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    container: true,
    'has-navbar-fixed-top': this.$store.getters.islogged
  },attrs:{"id":"app"}},[(this.$store.getters.islogged)?_c('caxton-nav'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }